// extracted by mini-css-extract-plugin
export default {"header":"Header_header__bH64k","container":"Header_container__r3bfu","flag":"Header_flag__m1Hwk","currency":"Header_currency__MRhRl","amount":"Header_amount__OrOKD"};